import { useState } from "react";
import "./appq.css";
import { useEffect } from 'react';
import FormInput from "./components/FormInput.js";
import { createSearchParams,useSearchParams, useNavigate, NavLink } from "react-router-dom";
import { db } from "./firebase";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { serverTimestamp } from "firebase/firestore";

const Infoform = () => {
  const [searchparams] = useSearchParams();
  const carrier = searchparams.get("carrier");
  const plan = searchparams.get("plan");
  const promo = searchparams.get("promo");
  const speed = searchparams.get("speed");
  const navigate = useNavigate();
  const [values, setValues] = useState({
    name: "",
    email: "",
    birthday: "",
    address: "",
    city: "",
    province: "",
    postalcode: "",
    simcard: "",
    oldNumber: "",
    accountNumber: "",
  });
  const [keepOldNumber, setKeepOldNumber] = useState(false);
  const [useAutoPay, setUseAutoPay] = useState(false);

  const inputs = [
    {
      id: 1,
      name: "simcard",
      type: "text",
      placeholder: "Please scan the sim card",
      errorMessage: "Please scan the sim card",
      label: "Simcard Number",
      required: true,
      iframe:  window !== window.parent
    },
    {
      id: 2,
      name: "name",
      type: "text",
      placeholder: "Name",
      errorMessage: "Please fill in your name",
      label: "Name",
      required: true,
      iframe: false
    },
    {
      id: 3,
      name: "email",
      type: "email",
      placeholder: "Email",
      // errorMessage: "It should be a valid email address! If you do not have an Email use noemail@icelltech.ca",
      label: "Email",
      // required: true,
      iframe: false
    },
    {
      id: 4,
      name: "birthday",
      type: "date",
      placeholder: "Birthday",
      label: "Birthday",
      iframe: false
    },
    {
      id: 5,
      name: "address",
      type: "text",
      placeholder: "Address",
      errorMessage: "Please put in your Address",
      label: "Address",
      required: true,
      iframe: false
    },
    {
      id: 6,
      name: "city",
      type: "text",
      placeholder: "City",
      errorMessage: "Please fill in your City name",
      label: "City",
      required: true,
      iframe: false
    },
    {
      id: 7,
      name: "province",
      type: "text",
      placeholder: "Province",
      errorMessage: "Please fill in your Province Name",
      label: "Province",
      required: true,
      iframe: false
    },
    {
      id: 8,
      name: "postalcode",
      type: "text",
      placeholder: "Postal Code",
      errorMessage: "Please fill in your Postal Code",
      label: "Postal Code",
      required: true,
      iframe: false
    },
  ];

  // Phone number validation function
  const isValidPhoneNumber = (phoneNumber) => {
    const phoneNumberRegex = /^\d{10}$/; // Assumes a 10-digit phone number
    return phoneNumberRegex.test(phoneNumber);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate the old number if it's provided
    if (keepOldNumber && !isValidPhoneNumber(values.oldNumber)) {
      alert("Please enter a valid 10-digit old phone number.");
      return;
    }

    db.collection("Topup")
      .add({
        Name: values.name,
        email: values.email!=""? values.email:'noemail@icelltech.ca',
        DOB: values.birthday,
        address: values.address,
        city: values.city,
        province: values.province,
        postalcode: values.postalcode,
        carrier: carrier,
        plan: plan +" "+ speed,
        promo: promo,
        active: "no",
        simcard: values.simcard,
        port: keepOldNumber,
        auto: useAutoPay,
        oldNumber: values.oldNumber,
        accountNumber: values.accountNumber,
        time: serverTimestamp(),
      })
      .then((docRef) => {
        alert("Data Successfully Submitted");
        navigate("/");
      })
      .catch((error) => {
        console.error("Error adding document: ", error);
      });
    console.log(values);
  };

  const onChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className="app" style={{ display: "flex", flexDirection: "column" }}>
      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <NavLink
          to={
              { pathname: '/planslucky', search: createSearchParams({ carrier: carrier }).toString() }}
          
        >
          <FontAwesomeIcon
            style={{
              position: "absolute",
              marginLeft: 10,
              marginTop: 25,
              color: "#663399",
            }}
            icon={faArrowLeft}
            className="fa-2xl"
          />
        </NavLink>
        <div style={{ width: "100%" }}>
          <h1 style={{ justifySelf: "center" }}>
            Activation {carrier} {plan} {speed}
          </h1>
        </div>
      </div>
      <form onSubmit={handleSubmit} style={{display:'flex', flexDirection:'column', alignitems:'center', justifyContent:'center'}}>
        {inputs.map((input) => (
          <FormInput
            key={input.id}
            {...input}
            value={values[input.name]}
            onChange={onChange}
            disabled= {input.iframe}
          />
        ))}
        <div style={{ margin: "20px 0" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
            Do you want to keep your old number?
          </label>
          <div style={{ display: "flex", gap: "10px" }}>
            <label>
              <input
                type="radio"
                name="keepOldNumber"
                value="yes"
                checked={keepOldNumber === true}
                onChange={() => setKeepOldNumber(true)}
                style={{ marginRight: "5px" }}
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                name="keepOldNumber"
                value="no"
                checked={keepOldNumber === false}
                onChange={() => setKeepOldNumber(false)}
                style={{ marginRight: "5px" }}
              />
              No
            </label>
          </div>
        </div>
        {keepOldNumber && (
          <div>
            <FormInput
              name="oldNumber"
              type="tel" // Use type "tel" for phone number input
              placeholder="Old Number"
              errorMessage="Please enter a valid 10-digit old phone number"
              label="Old Number"
              value={values.oldNumber}
              onChange={onChange}
              required
            />
            <FormInput
              name="accountNumber"
              type="text"
              placeholder="Account Number"
              errorMessage="Please enter your account number"
              label="Account Number"
              value={values.accountNumber}
              onChange={onChange}
              required
            />
            <label style={{ marginTop: "10px", color:'red', textAlign:'center' }}>
              Please note that to make a successful port, your old<br/> phone number must be active.
            </label>
          </div>
        )}
        <div style={{ margin: "20px 0" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "5px" }}>
            Would you like to use auto pay?
          </label>
          <div style={{ display: "flex", gap: "10px" }}>
            <label>
              <input
                type="radio"
                name="useAutoPay"
                value="yes"
                checked={useAutoPay === true}
                onChange={() => setUseAutoPay(true)}
                style={{ marginRight: "5px" }}
              />
              Yes
            </label>
            <label>
              <input
                type="radio"
                name="useAutoPay"
                value="no"
                checked={useAutoPay === false}
                onChange={() => setUseAutoPay(false)}
                style={{ marginRight: "5px" }}
              />
              No
            </label>
          </div>
        </div>
        <button>Submit</button>
      </form>
    </div>
  );
};

export default Infoform;
